import type { Guide } from '../types';

/**
 * S-21.10-27 — nr terminala Trimble na karcie pojazdu (pytanie 46; scenariusz e2e 22). DEMO 001 ma numer
 * z `e2e/setup/seed-e2e.ts`; pojazd nagrywarka bierze po numerze rejestracyjnym.
 */
export const guide: Guide = {
  flagKey: 'trimbleTerminalOnCard',
  title: 'Nr terminala Trimble na karcie pojazdu',
  whatItDoes:
    'W kartotece na karcie pojazdu jest nowy wiersz „Nr terminala Trimble”. To numer, który TMS opisywał dotąd jako telefon kierowcy — kierowcy nie mają telefonów służbowych, a numer należy do terminala w pojeździe. Wartość przychodzi z kartoteki pojazdów TMS przy każdym imporcie; gdy TMS jej nie podaje, stoi „—”.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-21.10-27'],
  steps: [
    {
      route: '/cars/:carId/show',
      record: { description: 'dowolny pojazd z floty', listPath: '/cars' },
      target: 'car-trimble-terminal',
      title: 'Wiersz w kartotece pojazdu',
      description:
        'Sekcja „Kartoteka” jest zwinięta na dole karty. Po rozwinięciu numer terminala stoi pod identyfikatorem pojazdu w TMS.',
      action: 'Otwórz pojazd z listy „Samochody” i rozwiń sekcję „Kartoteka”.',
      recorder: {
        account: 'ftl',
        demo: { kind: 'car', plate: 'DEMO 001' },
        actions: [{ kind: 'click', target: 'car-registry' }],
      },
    },
  ],
};
